import * as yup from 'yup';

export const createThreadSchema = yup.object().shape({
  title: yup.string().required('Le titre est obligatoire'),
  message: yup.string().required('Le message est obligatoire'),
  tags: yup.mixed(),
});
